import { render } from "./InputTextarea.vue?vue&type=template&id=2ba49500&scoped=true&ts=true"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"

import "./InputTextarea.vue?vue&type=style&index=0&id=2ba49500&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba49500"]])

export default __exports__